import '../styles/pages/Home.scss'
import banner from '../assets/banner.svg'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { SERVER } from '../hooks/config'
import { cachedGet } from '../utils/cachedApi'
import cat1 from '../assets/categories/ring.svg'
import CategoryCard from '../components/CategoryCard'
import prod1 from '../assets/products/prod1.png'
import ProductDisplayCard from '../components/ProductDisplayCard'
import { BsArrowRightShort } from "react-icons/bs";
import example1 from '../assets/perso1.svg'
import example2 from '../assets/perso2.svg'
import avis1 from '../assets/tem1.svg'
import avis2 from '../assets/tem2.svg'
import { IoStar } from "react-icons/io5";
import confiance from '../assets/icons/confiance.svg'
import qualite from '../assets/icons/qualite.svg'
import cadeau from '../assets/icons/cadeau.svg'
import ecology from '../assets/icons/ecologie.svg'

const chars = [
    {
        icon : confiance,
        title: 'Une relation de Confiance',
        description: 'La transparence, l\'écoute et la <br />satisfaction client sont au cœur<br />de notre démarche. Chaque<br />commande est traitée comme<br />une promesse à tenir.'
    },
    {
        icon : qualite,
        title: 'Une marque 100% tunisienne',
        description: 'Fier·e·s de nos racines, nous <br />soutenons l\'artisanat local,<br />en valorisant le savoir-faire<br />tunisien et les talents<br />de chez nous'
    },
    {
        icon : cadeau,
        title: 'Cadeaux personnalisés et uniques',
        description: 'Parce que chaque personne est<br />différente, nous proposons<br />des créations sur-mesure,<br />pensées pour faire plaisir<br />avec sincérité.'
    },
    {
        icon : ecology,
        title: 'Une démarche responsable',
        description: 'Nous privilégions les matériaux<br />durables, éthiques et respectueux<br />de l\'environnement, pour des<br />choix plus conscients.'
    }
]

const Home = () => {
    const [categories, setCategories] = useState([])
    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState({ categories: false, products: false })
    const navigate = useNavigate()
    const [currentIndex, setCurrentIndex] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(4);
    const [homeImages, setHomeImages] = useState({
        banner: null,
        perso: [],
        testimonials: [],
    });
    
    useEffect(() => {
        fetchData()
        fetchHomeImages();
    }, [])

    useEffect(() => {
        const handleResize = () => {
            setItemsPerPage(window.innerWidth < 768 ? 2 : 4);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const totalPages = Math.ceil(products.length / itemsPerPage);

    const handleDotClick = (page) => {
        setCurrentIndex(page * itemsPerPage);
    };

    const visibleProducts = products.slice(
        currentIndex,
        currentIndex + itemsPerPage
    );

    const fetchData = async () => {
        try {
            setLoading(true)
            setError({ categories: false, products: false })
            
            // Use cached API calls with 5 minute TTL
            const categoriesData = await cachedGet(`${SERVER}/categories`, { cacheTTL: 300000 });
            setCategories(categoriesData);
            
            const productsData = await cachedGet(`${SERVER}/products/bestof?limit=4`, { cacheTTL: 300000 });
            setProducts(productsData);
        } catch (error) {
            console.error('Error fetching data:', error)
            
            // Determine which API failed
            if (error.config?.url?.includes('/categories')) {
                setError(prev => ({ ...prev, categories: true }))
            } else if (error.config?.url?.includes('/products')) {
                setError(prev => ({ ...prev, products: true }))
            } else {
                // If we can't determine, mark both as error
                setError({ categories: true, products: true })
            }
        } finally {
            setLoading(false)
        }
    }

    const fetchHomeImages = async () => {
        try {
            setError(prev => ({ ...prev, images: false }));
            const data = await cachedGet(`${SERVER}/home/getImages`, { cacheTTL: 600000 }); // 10 minutes cache
            setHomeImages(data);
        } catch (error) {
            console.error('Error fetching home images:', error);
            setError(prev => ({ ...prev, images: true }));
        }
    };

    // Helper function to get image source
    const getImageSrc = (serverImage, fallbackImage) => {
        return serverImage ? `${SERVER}${serverImage}` : fallbackImage;
    };

    // Helper function to get array image source
    const getArrayImageSrc = (serverImages, index, fallbackImage) => {
        return serverImages && serverImages[index] ? `${SERVER}${serverImages[index]}` : fallbackImage;
    };

    const handleCategoryClick = (categoryId) => {
        if (categoryId) {
            navigate(`/products?category_id=${categoryId}`);
        }
    };

    return(
        <div className="home">
            <header className='home-header'>
                <div className='header-title'>
                    <h1> You create </h1>
                    <h1> your own piece of art </h1>
                    <button onClick={()=>navigate('/products')}> Explorer nos pièces </button>
                </div>
                <div className='header-image'>
                    <img src={getImageSrc(homeImages.banner, banner)} alt='home page banner' />
                </div>
            </header>
            <div className='home-categories'>
                <h2> Nos catégories </h2>
                <div className='categories-display'>
                    {loading ? (
                        <div className="loading-message">Chargement des catégories...</div>
                    ) : error.categories ? (
                        <div className="error-message">
                            <p>Impossible de charger les catégories pour le moment.</p>
                            <button onClick={fetchData} className="retry-button">Réessayer</button>
                        </div>
                    ) : categories.length > 0 ? (
                        categories.map((category, index) => (
                            <CategoryCard 
                                key={category.id || index}
                                image={category.image ? `${SERVER}${category.image}` : cat1} 
                                name={category.name} 
                                categoryId={category.id}
                                onClick={handleCategoryClick}
                            />
                        ))
                    ) : (
                        <div className="empty-message">Aucune catégorie disponible</div>
                    )}
                </div>
            </div>
            <div className='home-bestof'>
                <h2> Nos coups de coeurs </h2>
                {loading ? (
                    <div className="loading-message">Chargement des produits...</div>
                ) : error.products ? (
                    <div className="error-message">
                        <p>Impossible de charger les produits pour le moment.</p>
                        <button onClick={fetchData} className="retry-button">Réessayer</button>
                    </div>
                ) : products.length > 0 ? (
                    <>
                    <div className="bestof-display">
                        {visibleProducts.map((product, index) => (
                        <ProductDisplayCard
                            key={product.id || index}
                            product={product}
                            image={product.banner ? `${SERVER}${product.banner}` : prod1}
                        />
                        ))}
                    </div>
                    {products.length > itemsPerPage && (
                        <div className="dots">
                            {Array.from({ length: totalPages }).map((_, i) => (
                            <span
                                key={i}
                                className={`dot ${i === Math.floor(currentIndex / itemsPerPage) ? "active" : ""}`}
                                onClick={() => handleDotClick(i)}
                            />
                            ))}
                        </div>
                    )}
                    </>
                ) : (
                    <div className="empty-message">Aucun produit disponible</div>
                )}
            </div>
            <div className='home-perso'>
                <div className='home-perso-content'>
                    <h2> Votre cadeau, votre touche personnelle </h2>
                    <p> Tous nos articles sont pensés pour être uniques. Nous vous offrons la possibilité de personnaliser chaque pièce afin qu'elle reflète votre histoire, vos émotions et vos souvenirs. Chez Michkette.tn, chaque création est faite pour vous ressembler. Tous les bijoux et cadeaux exposés peuvent être personnalisés (gravure, initiales, prénoms, symboles, dates spéciales,photos…).{window.innerWidth > 768 ? <br/> : ' '}Vous imaginez, nous réalisons</p>
                    <button onClick={()=>navigate('/ArticlesPersonnalise')}> <BsArrowRightShort /> Personnalisez le vôtre maintenant </button>
                </div>
                <div className='home-perso-examples'>
                    <img src={getArrayImageSrc(homeImages.perso, 0, example1)} alt='example1' />
                    <img src={getArrayImageSrc(homeImages.perso, 1, example2)} alt='example2' />
                </div>
            </div>
            <div className='home-temois'>
                <h2> Ce que nos clients pensent </h2>
                <div className='temois-content'>
                    <div className='layer-1'>
                        <div className="stars">
                            {Array.from({ length: 5 }, (_, i) => (
                                <IoStar key={i} size={32}/>
                            ))}
                        </div>
                        <p>"J'adore mes nouvelles <br /> boucles d'oreilles<br /> de Michkette ! "</p>
                        <span> Zouhour Sghair </span>
                    </div>
                    <img src={getArrayImageSrc(homeImages.testimonials, 0, avis1)} alt='avis-1' />
                    <div className='layer-2'>
                        <div className="stars">
                            {Array.from({ length: 5 }, (_, i) => (
                                <IoStar key={i} size={32} />
                            ))}
                        </div>
                        <p> "Très jolie et apportent une <br /> touche féminine et raffinée à<br /> mon look. Je recommande<br /> vivement !" </p>
                        <span> Nesrine maarouf </span>
                    </div>
                    <img src={getArrayImageSrc(homeImages.testimonials, 1, avis2)} alt='avis-2' />
                </div>
            </div>
            <div className='qualities'>
                {chars.map((char, index) => (
                    <div key={index} className='quality-card'>
                        <img src={char.icon} alt={char.title} />
                        <h3> {char.title} </h3>
                        <p dangerouslySetInnerHTML={{ __html: char.description }} />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Home